import { managementWithBearerPostRequest } from './../vidCloud/managementRequest';

const SupportTicketService = {};

SupportTicketService.sendSupportTicket = (body) => {

  return managementWithBearerPostRequest('/supporttickets', body);
}

export default SupportTicketService;